import { render, staticRenderFns } from "./Triage.vue?vue&type=template&id=56778c8d&scoped=true&"
import script from "./Triage.vue?vue&type=script&lang=js&"
export * from "./Triage.vue?vue&type=script&lang=js&"
import style0 from "./Triage.vue?vue&type=style&index=0&id=56778c8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56778c8d",
  null
  
)

export default component.exports